import { ContractAddress, GeneralSettings } from '../../../shared/api/contract';
import { ContractAbi } from 'web3';
import { ConnectorType } from '@reown/appkit';

import { MoonStaking } from '../../../shared/api/contract/ethers/moon-staking';
import i18n from "../../../i18n.ts";

export class AddDepositService extends MoonStaking {
    constructor(contractAddress: ContractAddress, abi: ContractAbi, provider: ConnectorType, walletAddress: ContractAddress) {
        super(contractAddress, abi, provider, walletAddress);
    }

    async createDeposit(amount: string, lockType: 0 | 1 | 2, address: ContractAddress, setMessage: (msg: string) => void): Promise<boolean> {
        try {
            const gasEstimate = await this.contract.estimateGas.deposit(BigInt(Number(amount)) * BigInt(1000000000000000000), lockType);


            setMessage(i18n.t('approve_deposit'));
            const tx = await this.contract.deposit(BigInt(Number(amount)) * BigInt(1000000000000000000), lockType, {
                gasLimit: gasEstimate.mul(110).div(100),
            });
            console.log(tx);
            setMessage(i18n.t('got_approve_deposit'));
            const receipt = await tx.wait();
            console.log(receipt);
            return true;
        } catch (error) {
            console.log(error);

            return false;
        }
    }
}
